import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { worker } from './mocks/browser'
import { setupDatadog } from './utils/Datadog'

if (!process.env.VITE_HANDY_SERVER_ENDPOINT) {
  worker.start()
}
const STAGE = process.env.VITE_STAGE || 'local'
setupDatadog(STAGE)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
